import React, { Component } from 'react';
import '../css/style.css';
import '../components/Home.css';
import EventPagingLayout from './EventPagingLayout';
import SearchLayout from './SearchLayout';
import {GREEN_BG, GREEN_BORDER} from '../backend/Colors';

import { translate } from "react-i18next";


class EventSubscriptionsLayout extends Component {

    render(){
        const { t } = this.props;
        const { params } = this.props.match
         return (<SearchLayout title={t("Abos")} eventKey="4"  searchType="ACTIVTY" bg={GREEN_BG} bgStrong={GREEN_BORDER}>
         
         <EventPagingLayout preURL="subscription/events" id={params.id} />
     </SearchLayout>)
       }
}

export default translate("translations")(EventSubscriptionsLayout);